export const LastText = () => {
    return (
      <div className='LastText'>
        <p>© 2021 ONCF -Tous droits réservés</p>
      </div>
    )
  }